<!--
 * @Author: YuanYuan
 * @Date: 2024-02-28 10:31:05
 * @LastEditTime: 2024-02-28 11:18:31
 * @description: 查询条件中ws-select-search控件
-->
<template>
  <ws-select-search
    class="w-full"
    multiple-filter-split=";"
    :filter-placeholder="$t('common.splitSemicolon')"
    v-bind="$attrs"
    v-on="$listeners">
    <span slot="prefix">{{label}}{{$t('common.colon')}}</span>
  </ws-select-search>
</template>

<script setup>
import { toRefs } from 'vue'

const props = defineProps({
  label: {
    type: String,
    default: '-'
  }
})

const { label } = toRefs(props)
</script>
